import { combineReducers } from 'redux';
import { templatesSlice } from '../slices/templates';
import { mainServerAssistApi } from '../services/assist';
import analytics from './analytics';
import auth from './auth';
import jobs from './jobs';
import ui from './ui';
import users from './users';
import profile from './profile';
import notification from './notification';
import organizations from './organizations';
import subgroups from './subgroups';
import socket from './socket';
import chatLog from './chatLog';
import groups from './groups';
import operators from './operators';
import participants from './participants';
import media from './media';
import searchGroups from './search-groups';

const appReducer = combineReducers({
  analytics,
  auth,
  jobs,
  notification,
  operators,
  organizations,
  subgroups,
  profile,
  templates: templatesSlice.reducer,
  ui,
  users,
  socket,
  chatLog,
  groups,
  participants,
  media,
  [mainServerAssistApi.reducerPath]: mainServerAssistApi.reducer,
  searchGroups,
});

export default appReducer;
